import React from 'react';

import { Spacer } from '@repo/ui/components/Spacer';
import { H5, P4 } from '@repo/ui/components/Typography';
import { ProfileImage } from '@repo/ui/deprecated/ProfileImage';
import { themeStyle } from '@repo/ui/theming';
import { buildProfileImageUrl } from '@repo/utils/url';

import { FlexColumn, FlexRow } from 'styles/layouts';

import {
  Loader,
  Suggestion,
  SuggestionContent,
  SuggestionsWrapper,
} from './styles';
import { SuggestionListProps } from './types';

export const SuggestionList: React.FC<SuggestionListProps> = (props) => {
  return (
    <SuggestionsWrapper theme={props.theme}>
      {props.loading && <Loader />}
      <FlexColumn
        ref={props.suggestionsRef}
        height="100%"
        style={{ overflow: 'hidden' }}
      >
        {props.suggestions.map((suggestion, i) => (
          <Suggestion
            key={suggestion.slug}
            isActive={!props.loading && i === props.activeSuggestion}
            theme={props.theme}
            onPointerEnter={(): void =>
              props.onSetActive && props.onSetActive(i)
            }
            onPointerUp={props.onClick}
          >
            <SuggestionContent>
              <FlexRow alignItems="center" style={{ overflow: 'hidden' }}>
                <ProfileImage
                  profile={{
                    profileImage: buildProfileImageUrl(
                      suggestion.imageUrl ?? undefined
                    ),
                    name: suggestion.name,
                    isTeam: suggestion.isTeam,
                  }}
                  size="30px"
                  // to show cursor pointer
                  onClick={props.onClick}
                />
                <Spacer width="6px" />
                <FlexColumn style={{ overflow: 'hidden' }}>
                  <H5 noTextOverflow style={{ lineHeight: '15px' }}>
                    {suggestion.name}
                  </H5>
                  <P4 noTextOverflow color={themeStyle.varInkMedium}>
                    @{suggestion.slug}
                  </P4>
                </FlexColumn>
              </FlexRow>
            </SuggestionContent>
          </Suggestion>
        ))}
      </FlexColumn>
    </SuggestionsWrapper>
  );
};
